module.exports = __webpack_public_path__ + "img/area_15.7aaccfe0.svg";